module.exports = __webpack_public_path__ + "static/Automotive-Companies-fac4511a0f24f085239e940f2a0439bb.jpg";